import { useState, useEffect } from "react";
import { getFilterData } from "../../../Api/Api";
import FlatMultiSelectFilter from "./FlatMultiSelectFilter";

const FILTER_CONFIG = {
  type: "dynamic",
  queryParams: {
    table: "batteryConfigList",
    column: "configName",
  },
};

const ConfigurationFilter = ({ selectedValues, onChange }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    getFilterData(FILTER_CONFIG).then((res) => {
      const data = res?.response?.response?.filterData || [];
      setOptions(data.map((item) => item.id));
    });
  }, []);

  return (
    <FlatMultiSelectFilter
      label="Configuration"
      options={options}
      selectedValues={selectedValues}
      onChange={onChange}
    />
  );
};

export default ConfigurationFilter;
